import { Account } from './types';
export type AuthAction = LoginAction | SetUserAccountIdAction | SetAccountAction;

export interface LoginAction {
  type: 'AUTH_LOGIN_SUCCESS';
  data: {
    username: string;
  };
}

export function loginSuccess(username: string): LoginAction {
  return {
    type: 'AUTH_LOGIN_SUCCESS',
    data: {
      username,
    },
  };
}

export interface SetUserAccountIdAction {
  type: 'AUTH_SET_USER_ACCOUNT_ID';
  data: {
    userAccountId: string;
  };
}

export function setUserAccountId(userAccountId: string): SetUserAccountIdAction {
  return {
    type: 'AUTH_SET_USER_ACCOUNT_ID',
    data: {
      userAccountId,
    },
  };
}

export interface SetAccountAction {
  type: 'AUTH_SET_ACCOUNT';
  data: {
    account: Account;
  };
}

export function setAccount(account: Account): SetAccountAction {
  return {
    type: 'AUTH_SET_ACCOUNT',
    data: {
      account,
    },
  };
}
